import { render, staticRenderFns } from "./WidgetAgencyActivitySegment.vue?vue&type=template&id=c8af01b4"
import script from "./WidgetAgencyActivitySegment.vue?vue&type=script&lang=js"
export * from "./WidgetAgencyActivitySegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports